export const getStarText = (number, isWhite = false) => {
  let text = "";
  for (let i = 0; i < number; i++) {
    text += isWhite ? "☆" : "★";
  }
  return text;
};